export default function combineAddressParts(
  parts: Array<string | undefined | null> = [],
): string {
  return parts.filter(part => Boolean(part)).join(' ');
}
